import styled from 'styled-components';

import { Button } from '../../../../Toolkit/Button';
import { Loading } from '../../../../Toolkit/Loading/Loading';
import { donedealBreakpoints } from 'styled-system';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.M16};
  padding-top: ${({ theme }) => theme.spacing.M32};
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S4};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  ${({ theme }) => theme.typography.fontSizes.B14};
  color: ${({ theme }) => theme.donedeal.colors.GREY_DARKER};
  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
`;

export const NextButton = styled(Button)`
  display: grid;
  grid-template-areas: 'stack';
  justify-content: center;
  align-items: center;
  flex: 1;
  max-width: 160px;
  height: 48px;

  ${donedealBreakpoints.media.medium} {
    flex: none;
    max-width: none;
    width: fit-content;
    min-width: 156px;
    padding: 0 ${({ theme }) => theme.spacing.M16};
  }
`;

// https://www.linkedin.com/posts/wesbos_how-do-you-make-a-button-that-doesnt-resize-activity-7272663944106782720-ksgB
export const SubmitButton = styled(Button)`
  display: grid;
  grid-template-areas: 'stack';
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${donedealBreakpoints.media.medium} {
    width: fit-content;
    padding: ${({ theme }) => `0 ${theme.spacing.S12}`};
    margin-bottom: 0;
  }
`;

export const ButtonText = styled.span<{ isSubmitting: boolean }>`
  grid-area: stack;
  ${({ isSubmitting }) => isSubmitting && 'opacity: 0;'}
`;

export const Spinner = styled(Loading)<{ isSubmitting: boolean }>`
  grid-area: stack;
  justify-self: center;
  ${({ isSubmitting }) => !isSubmitting && 'opacity: 0;'}
`;
